import React from "react";
import { Card, Typography } from "antd";

const { Title, Paragraph } = Typography;

const HelpSupport = () => {
  return (
    <div className="mainContain">
      <Title level={3}>Help & Support</Title>

      <Card className="mb-3">
        <Title level={4}>💡 How can we help you?</Title>
        <Paragraph>
          If you're facing issues with transactions, complaints, or login
          problems — you can reach out directly to our support team.
        </Paragraph>
      </Card>

      <Card className="mb-3">
        <Title level={4}>📞 Contact Information</Title>
        <Paragraph>
          Email:{" "}
          <a href="mailto:agent.support@plutos.one">agent.support@plutos.one</a>
        </Paragraph>
      </Card>

    
    </div>
  );
};

export default HelpSupport;